import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '../api.module';
import {
  ApiMessagingHelperPipe,
  ApiMessagingHelperUnPurePipe,
} from './messaging-helper.pipe';

@NgModule({
  declarations: [ApiMessagingHelperPipe, ApiMessagingHelperUnPurePipe],
  imports: [CommonModule, ApiModule],
  exports: [ApiMessagingHelperPipe, ApiMessagingHelperUnPurePipe],
  providers: [ApiMessagingHelperPipe, ApiMessagingHelperUnPurePipe],
})
export class ApiMessagingModule {}
